import {
  WAREHOUSE_RECEIVING_ORDERS_INDEX_REQUESTED,
  WAREHOUSE_RECEIVING_ORDERS_INDEX_SUCCESS,
  WAREHOUSE_RECEIVING_ORDERS_INDEX_FAILURE,
  WAREHOUSE_RECEIVING_ORDER_FIND_REQUESTED,
  WAREHOUSE_RECEIVING_ORDER_FIND_SUCCESS,
  WAREHOUSE_RECEIVING_ORDER_FIND_FAILURE,
  WAREHOUSE_RECEIVING_ORDER_REMOVE_REQUESTED,
  WAREHOUSE_RECEIVING_ORDER_REMOVE_SUCCESS,
  WAREHOUSE_RECEIVING_ORDER_REMOVE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  status: 'waiting',
  continuationToken: null,
  lastPage: null,
  activeWro: null,
  variants: null,
  products: null,
  warehouseReceivingOrders: [],
  errors: null
};

const warehouseReceivingOrders = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case WAREHOUSE_RECEIVING_ORDER_FIND_REQUESTED:
    case WAREHOUSE_RECEIVING_ORDERS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        warehouseReceivingOrders: [],
        status: 'requesting',
        activeWro: null,
        variants: null,
        products: null,
        lastPage: null,
        errors: null,
      });

    case WAREHOUSE_RECEIVING_ORDER_FIND_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        lastPage: null,
        warehouseReceivingOrders: [],
        activeWro: action.payload.warehouse_receiving_order,
        variants: action.payload.variant_results,
        products: action.payload.product_results,
        errors: null
      })

    case WAREHOUSE_RECEIVING_ORDERS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        warehouseReceivingOrders: action.payload.warehouse_receiving_orders,
        activeWro: null,
        errors: null
      });


    case WAREHOUSE_RECEIVING_ORDER_REMOVE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        errors: null,
      });

    case WAREHOUSE_RECEIVING_ORDER_REMOVE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        warehouseReceivingOrders: action.payload.warehouse_receiving_orders,
        activeWro: null,
        errors: null,
      });

    case WAREHOUSE_RECEIVING_ORDER_REMOVE_FAILURE:
    case WAREHOUSE_RECEIVING_ORDER_FIND_FAILURE:
    case WAREHOUSE_RECEIVING_ORDERS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        activeWro: null,
        lastPage: null,
        warehouseReceivingOrders: [],
        errors: 'error here'
      });

    default:
      return state;
  }
}

export default warehouseReceivingOrders;